var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6571 20H3.34292C1.50308 20 0 18.4969 0 16.6571V3.34292C0 1.50308 1.50308 0 3.34292 0H16.6571C18.4969 0 20 1.50308 20 3.34292V16.6571C20 18.5051 18.5051 20 16.6571 20Z",
    fill: "#EE2D2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0046 15.1373C8.6329 15.1373 7.34337 14.6034 6.37417 13.6342C5.40497 12.665 4.87109 11.3755 4.87109 10.0038C4.87109 8.63217 5.40497 7.34264 6.37417 6.37344C7.34337 5.40424 8.6329 4.87036 10.0046 4.87036C11.3762 4.87036 12.6658 5.40424 13.635 6.37344C14.6042 7.34264 15.138 8.63217 15.138 10.0038C15.138 11.3755 14.6042 12.665 13.635 13.6342C12.6575 14.6034 11.3762 15.1373 10.0046 15.1373ZM10.0046 5.96276C7.77869 5.96276 5.9635 7.76975 5.9635 10.0038C5.9635 12.2297 7.77048 14.0449 10.0046 14.0449C12.2304 14.0449 14.0456 12.2379 14.0456 10.0038C14.0374 7.77796 12.2304 5.96276 10.0046 5.96276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.138 4.70177C16.6824 4.70177 17.1236 4.26048 17.1236 3.71612C17.1236 3.17176 16.6824 2.73047 16.138 2.73047C15.5936 2.73047 15.1523 3.17176 15.1523 3.71612C15.1523 4.26048 15.5936 4.70177 16.138 4.70177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta_icon.ce7bc6c1.svg";
export { ForwardRef as ReactComponent };